//Basic imports
import React, { Component , useState} from 'react';

//Custom IMPORTS: 

//Menu import
import MenuButton from '../Buttons/MenuButton/MenuButton.js';
import '../PageCss/homepage.css';

import HeaderSection from'../HeaderSections/HeaderAbout.js'

const AboutPage = () => {

    
    return (

        <HeaderSection />
      
       
    )

};

export default AboutPage;